module.exports = __webpack_public_path__ + "assets/img/bannerjituan.081784cb.png";